import React from 'react';
import AvailabilityRow from "./AvailabilityRow";
import AvailabilityHeading from "./AvailabilityHeading";
import {
  Table,
  TableBody,
  TableHeader,
  TableRow
} from 'material-ui/Table';
import {getRateCurrency, propertyHasRates} from "../utils/Util";

const AvailabilityTable = ({property, criteria, showRate, customer, displayNoOfNights}) => {
  const rows = [];
  for (let i = 0; i < property.inventory.length; i++) {
    if (property.inventory[i].rateByDay
        && property.inventory[i].rateByDay.length > 0) {
      rows.push(<AvailabilityRow key={i} property={property}
                                 inventoryType={property.inventory[i]}
                                 showRate={showRate}
                                 customer={customer}
                                 displayNoOfNights={displayNoOfNights}
                                 criteria={criteria}/>)
    }
  }

  let heading = property ? <AvailabilityHeading criteria={criteria}
                                                showRate={showRate
                                                && propertyHasRates(property)}
                                                displayNoOfNights={displayNoOfNights}
                                                currency={getRateCurrency(
                                                    property)}
      />
      : <TableRow/>;

  return (
      <div className="availabilityGrid">
        <Table style={styles.customStyle}>
          <TableHeader adjustForCheckbox={false}>
            {heading}
          </TableHeader>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </div>
  );
};

const styles = {
  customStyle: {
    fontFamily: 'inherit'
  },
};

export default AvailabilityTable;


// WEBPACK FOOTER //
// ./src/components/AvailabilityTableComponent.js